import Form from '../../../../form_builder_2/form';
import AnalyticsHelper from '../../../../utils/analytics-helper';

export default class RegisterView {
    constructor(parent) {
        this.parent = parent;
        this.util = this.parent.parent;
        this.el = parent.el.querySelector('.register-view');
        this.registerLogin = this.el.querySelector('.register-form-login');
        this.form = new Form(this.parent.el.querySelector('.register-form'), {
            onSuccess: this.onSuccess.bind(this),
            onError: this.onError.bind(this),
        });
        this.bind();
    }

    bind() {
        this.registerLogin?.addEventListener('click', (e) => {
            e.preventDefault();
            this.parent.show({ view: 'login', tab: 'login' });
        });
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }

    onSuccess(result) {
        this.parent.hide();
        this.util.onLogin();

        this.analyticsPush(result);
    }

    onError(result) {
        if (result?.token == false) {
            this.parent.show({ view: 'login', tab: 'register', message: this.el.dataset.otpExpiredError });
        } else {
            this.form.showError();
        }

        this.analyticsPush(result);
    }

    back() {
        this.parent.show({ view: 'register-validate-otp' });
    }

    analyticsPush(result) {
        const customerId = window.HONDA.MyAccount2.id();
        AnalyticsHelper.push({
            event:'my_account',
            eventCategory:'my account',
            eventAction:'Registration Submit CTA',
            eventLabel:`${dataLayer[0].productCategory}|My account|Complete registeration|internal|form submitted|#`,
            actionType:'Registration Submit CTA',
            businessUnit : dataLayer[0].productCategory,
            moduleName:'My account',
            clickText:'Complete registeration',
            clickType:'internal', 
            registrationStep:'form submitted',
            destinationURL:'#',
        });

        result.success ?  AnalyticsHelper.push({
            event: 'my_account_success',
            eventCategory: 'my account success',
            eventAction: 'Registration Result',
            eventLabel: `${dataLayer[0].productCategory}|My account|Complete registeration|internal|#`,
            actionType: 'Registration Result',
            businessUnit: dataLayer[0].productCategory,
            moduleName: 'My account',
            clickText: 'Complete registeration',
            clickType: 'internal',
            destinationURL: '#',
            accountId: customerId,
        }) : AnalyticsHelper.push({
            event: 'my_account_failed',
            eventCategory: 'my account failed',
            eventAction: 'Registration Result',
            eventLabel: `${dataLayer[0].productCategory }|My account|Complete registeration|internal|#`,
            actionType: 'Registration Result',
            businessUnit: dataLayer[0].productCategory,
            moduleName: 'My account',
            clickText: 'Complete registeration',
            clickType: 'internal',
            destinationURL: '#',
        });
    }
}
